<div class="test">
    <h1>Hey TODO!</h1>
    <ul>
        <li *ngFor="let t of todos" class="todo">{{ t.title }}</li>
    </ul>
</div>